module.exports = __webpack_public_path__ + "static/media/game-display-2@2x.fb0ee956.png";